/**
 * @module pages/TermsPage
 * @description Terms and Conditions tab. Renders config/terms.ts; until AFJ
 * supplies the text it says so plainly instead of showing invented terms.
 */
import { TERMS } from "../config/terms";
import { ABOUT_YOUR_GIFT, CAMPAIGN } from "../config/campaign";

export function TermsPage() {
    const pending = TERMS.sections.length === 0;
    return (
        <section className="page-narrow terms">
            <p className="pc-kicker">{CAMPAIGN.campaignName}</p>
            <h1 className="section-title">Terms and Conditions</h1>
            {TERMS.lastUpdated && <p className="terms-updated">Last updated {TERMS.lastUpdated}</p>}
            {pending ? (
                <p className="terms-pending" role="note">
                    The Terms and Conditions for {CAMPAIGN.campaignName} are being finalized by {CAMPAIGN.organizationName} and
                    will appear here. For questions in the meantime, call {CAMPAIGN.phone} or write to {CAMPAIGN.mailingAddress}.
                </p>
            ) : (
                TERMS.sections.map((section) => (
                    <section key={section.heading}>
                        <h2>{section.heading}</h2>
                        {section.paragraphs.map((p, i) => (
                            <p key={i}>{p}</p>
                        ))}
                    </section>
                ))
            )}
            <section>
                <h2>About your gift</h2>
                <p>{ABOUT_YOUR_GIFT}</p>
            </section>
        </section>
    );
}
